import React, { useState, createRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const CaptchaButton = ({ setCaptchaToken, button, captchaKey }) => {
  const SITE_KEY = captchaKey;
  const [callback, setCallback] = useState("not fired");
  const [expired, setExpired] = useState("false");
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);
  const _reCaptchaRef = createRef();

  const handleChange = (value) => {
    setCaptchaToken(value);
    if (value === null) {
      setExpired("true");
      setCaptchaToken("");
    }
    _reCaptchaRef.current.reset();
  };

  const asyncScriptOnLoad = () => {
    setCallback("called!");
    setRecaptchaLoaded(true);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    _reCaptchaRef.current.execute();
  };
  return (
    <>
      <ReCAPTCHA
        style={{ display: "inline-block" }}
        size="invisible"
        ref={_reCaptchaRef}
        sitekey={SITE_KEY}
        onChange={handleChange}
        asyncScriptOnLoad={asyncScriptOnLoad}
        badge={"bottomleft"}
      />
      {React.cloneElement(button, { onClick: onSubmit })}
    </>
  );
};

export default CaptchaButton;
